module.exports = __webpack_public_path__ + "media/robot.307b83c8.svg";